import { Button, Row, Col, Form } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import SectionSeparator from "../SectionSeparator";
import SignaturePad from "../SignaturePad";

const TermsConditionsStep = ({ ctx }) => {
  const {
    formData,
    setFormData,
    errors,
    admissionAttachments,
    setAdmissionAttachmentModal,
    signature,
    setSignature,
  } = ctx;

  return (
    <>
      {admissionAttachments.length > 0 && (
        <>
          <SectionSeparator title="title.settling_in_policy" />
          <ul>
            {admissionAttachments.map((attachment, index) => (
              <li key={index}>
                <Button
                  onClick={() =>
                    setAdmissionAttachmentModal({
                      show: true,
                      title: attachment.title,
                      content: attachment.text,
                    })
                  }
                  variant="link"
                >
                  {attachment.title}
                </Button>
              </li>
            ))}
          </ul>
        </>
      )}
      <SectionSeparator title="title.acknowledgement" />
      <Row className="mb-4">
        <Col md={"auto"}>
          <Form.Check
            checked={formData?.check_acknowledgement == 1}
            type="checkbox"
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                check_acknowledgement: e.target.checked ? 1 : 0,
              }))
            }
          />
        </Col>
        <Col>
          <FormattedMessage id="acknowledgement" />
        </Col>
      </Row>
      {/* Declaration Text */}
      <div className="mb-4 p-3 border rounded bg-light">
        <p className="mb-0" style={{ fontSize: "14px", lineHeight: "1.6" }}>
          <FormattedMessage id="declaration.text" />
        </p>
      </div>

      <SignaturePad
        signature={signature}
        setSignature={setSignature}
        admissionID={formData.admission_id}
        setFormData={setFormData}
        error={errors?.signature}
      />
    </>
  );
};

export default TermsConditionsStep;
